import type { HotelsLocale } from './en'

export const hotelsTeIn = {
  nav: {
    dashboard: 'డ్యాష్‌బోర్డ్',
    settings: 'సెట్టింగులు',
    wakeupScheduling: 'వేక్-అప్ షెడ్యూలింగ్',
    wakeupHistory: 'వేక్-అప్ చరిత్ర',
  },
  common: {
    unknown: 'తెలియదు',
    notAvailable: 'N/A',
    placeholder: '—',
    search: 'వెతకండి',
    entries: 'ఎంట్రీలు',
    show: 'చూపు',
    retry: 'మళ్లీ ప్రయత్నించండి',
    loading: 'లోడ్ అవుతోంది',
    previous: 'మునుపటి',
    next: 'తర్వాత',
    dayPlaceholder: 'రోజు...',
    timePlaceholder: 'సమయం...',
    filterTimesPlaceholder: 'సమయాలను ఫిల్టర్ చేయండి...',
  },
  dialogs: {
    confirm: 'నిర్ధారించు',
    cancel: 'రద్దు',
  },
  errors: {
    loadRooms: 'గదులను లోడ్ చేయడంలో విఫలమైంది',
    loadWakeupHistory: 'వేక్-అప్ చరిత్రను లోడ్ చేయడంలో విఫలమైంది',
    loadPbxSettings: 'PBX సెట్టింగులను లోడ్ చేయడంలో విఫలమైంది',
    loadExtensions: 'ఎక్స్‌టెన్షన్‌లను లోడ్ చేయడంలో విఫలమైంది',
  },
  pagination: {
    previousPage: 'మునుపటి పేజీ',
    nextPage: 'తర్వాతి పేజీ',
    resultsPerPage: 'పేజీకి ఫలితాలు:',
    all: 'అన్నీ',
    jumpToPage: 'పేజీ {{page}} కు వెళ్ళండి',
    recordRange: '{{start}}—{{end}} / {{total}} మొత్తం',
    recordRangeEmpty: '0 / 0',
  },
  tableToolbar: {
    entriesOnly: '{{count}} ఎంట్రీలు',
    entriesFiltered: '{{total}} లో {{filtered}} ఎంట్రీలు',
    resultsPerPage: 'ప్రతి పేజీకి ఫలితాలు:',
    showingSummary: '{{count}} లో {{start}}-{{end}} చూపిస్తోంది',
  },
  datePresets: {
    today: 'ఈ రోజు',
    tomorrow: 'రేపు',
    yesterday: 'నిన్న',
    '1week': '1 వారం',
    '2weeks': '2 వారాలు',
    '3weeks': '3 వారాలు',
    '4weeks': '4 వారాలు',
    all: 'అన్నీ',
  },
  wakeupStatus: {
    scheduled: 'షెడ్యూల్ చేయబడింది',
    tried: 'ప్రయత్నించబడింది',
    cleared: 'తొలగించబడింది',
    canceled: 'రద్దు చేయబడింది',
  },
  dashboard: {
    incomingCallHistory: 'ఇన్‌కమింగ్ కాల్ చరిత్ర',
    emergencyHistory: '911 చరిత్ర (7 రోజులు)',
    roomStatus: 'గది స్థితి',
    searchCalls: 'కాల్స్ వెతకండి...',
    noIncomingCalls: 'ఇన్‌కమింగ్ కాల్స్ లేవు',
    noMatchingCalls: 'మీ వెతుకులాటకు సరిపోయే కాల్స్ లేవు',
    number: 'నంబర్',
    name: 'పేరు',
    time: 'సమయం',
    destination: 'గమ్యం',
    room: 'గది',
    timeAndDate: 'సమయం & తేదీ',
    duration: 'వ్యవధి',
    noEmergencyCalls: 'కాల్స్ లేవు',
    emergencyFooter: '* {{destination}} కు కాల్ చేయబడింది',
    refreshingIn: '{{seconds}}సె లో రిఫ్రెష్ అవుతుంది',
    noRoomsTitle: 'గదులు కనబడలేదు',
    noRoomsDescription: 'ఈ PBX కోసం హాస్పిటాలిటీ గదులు కాన్ఫిగర్ చేయబడలేదు.',
    resetRoomsSuccess: '{{count}} గదులు Dirty కి రీసెట్ చేయబడ్డాయి',
    resetRoomsFailed: 'గదులను రీసెట్ చేయడంలో విఫలమైంది',
    roomStatusActions: {
      dirty: `Dirty`,
      clean: `Clean`,
      occupied: `Occupied`,
      inspected: `Inspected`,
    },
    roomTile: {
      openAria: 'గది {{room}} తెరవండి',
    },
    roomDetail: {
      title: 'గది {{room}}',
      changeStatus: 'స్థితి మార్చు',
      cleanOrInspectedWarning:
        'Clean లేదా Inspected గా మార్చితే యాక్టివ్ వేక్-అప్ కాల్స్ రద్దవుతాయి మరియు వాయిస్‌మెయిల్స్ తొలగించబడతాయి.',
      activeWakeups: 'యాక్టివ్ వేక్-అప్స్',
      voicemails: 'వాయిస్‌మెయిల్స్',
      statusUpdated: 'గది స్థితి నవీకరించబడింది',
      statusUpdateFailed: 'గది స్థితి నవీకరించడంలో విఫలమైంది',
    },
    resetAllRooms: {
      button: 'అన్ని గదులను Dirty కి రీసెట్ చేయండి',
      title: 'అన్ని గదులను రీసెట్ చేయండి',
      description:
        'ఇది అన్ని గదులను Dirty స్థితికి సెట్ చేస్తుంది. వేక్-అప్ కాల్స్ మరియు వాయిస్‌మెయిల్స్ ప్రభావితం కావు. మీరు ఖచ్చితంగా కొనసాగాలనుకుంటున్నారా?',
      confirm: 'అన్నీ రీసెట్ చేయి',
    },
    wakeupPopover: {
      title: 'వేక్-అప్ కాల్స్',
      manageAria: 'వేక్-అప్ కాల్స్‌ను నిర్వహించండి',
      manageAriaPending: 'వేక్-అప్ కాల్స్‌ను నిర్వహించండి (పెండింగ్‌లో ఉంది)',
      manageAriaCleared: 'వేక్-అప్ కాల్స్‌ను నిర్వహించండి (తొలగించబడింది)',
      clearAll: 'అన్నీ తొలగించాలా?',
      clearAllSuccess: '{{count}} వేక్-అప్{{suffix}} రద్దు చేయబడింది',
      clearAllFailed: 'వేక్-అప్స్ తొలగించడంలో విఫలమైంది',
      scheduleSuccess: 'వేక్-అప్ కాల్ షెడ్యూల్ చేయబడింది',
      scheduleFailed: 'వేక్-అప్ షెడ్యూల్ చేయడంలో విఫలమైంది',
      addAria: 'వేక్-అప్ కాల్ జోడించండి',
      loading: 'లోడ్ అవుతోంది...',
      none: 'యాక్టివ్ వేక్-అప్ కాల్స్ లేవు',
      schedule: 'షెడ్యూల్',
      cancelAria: 'వేక్-అప్ రద్దు చేయండి',
      cancelAriaWithTime: '{{time}} వేక్-అప్ రద్దు చేయండి',
    },
    voicemailPopover: {
      title: 'వాయిస్‌మెయిల్స్',
      manageAria: 'వాయిస్‌మెయిల్స్‌ను నిర్వహించండి',
      manageAriaWithCount_one:
        'వాయిస్‌మెయిల్స్‌ను నిర్వహించండి ({{count}} వాయిస్‌మెయిల్)',
      manageAriaWithCount_other:
        'వాయిస్‌మెయిల్స్‌ను నిర్వహించండి ({{count}} వాయిస్‌మెయిల్స్)',
      clearAll: 'అన్నీ తొలగించాలా?',
      clearAllSuccess_one: '{{count}} వాయిస్‌మెయిల్ తొలగించబడింది',
      clearAllSuccess_other: '{{count}} వాయిస్‌మెయిల్స్ తొలగించబడ్డాయి',
      clearAllFailed: 'వాయిస్‌మెయిల్స్ తొలగించడంలో విఫలమైంది',
      loading: 'లోడ్ అవుతోంది...',
      none: 'వాయిస్‌మెయిల్స్ లేవు',
      status: 'స్థితి',
      received: 'స్వీకరించిన సమయం',
      from: 'నుంచి',
      read: 'చదివినది',
      new: 'కొత్తది',
      deleteAria: 'వాయిస్‌మెయిల్ తొలగించండి',
      deleteSuccess: 'వాయిస్‌మెయిల్ తొలగించబడింది',
      deleteFailed: 'వాయిస్‌మెయిల్ తొలగించడంలో విఫలమైంది',
    },
  },
  wakeupScheduler: {
    scheduleSuccess: '{{count}} వేక్-అప్ కాల్{{suffix}} షెడ్యూల్ చేయబడింది',
    scheduleFailed: 'వేక్-అప్ కాల్స్ షెడ్యూల్ చేయడంలో విఫలమైంది',
    selectDate: 'తేదీని ఎంచుకోండి',
    selectTime: 'సమయాన్ని ఎంచుకోండి',
    scheduleWakeupCalls: 'వేక్-అప్ కాల్స్ షెడ్యూల్ చేయండి',
    scheduling: 'షెడ్యూల్ చేస్తోంది...',
    selectedRooms: '{{count}} గది{{suffix}} ఎంపిక చేయబడింది',
    cancelSuccess: 'వేక్-అప్ కాల్ రద్దు చేయబడింది',
    cancelFailed: 'వేక్-అప్ కాల్ రద్దు చేయడంలో విఫలమైంది',
    addToPendingAria: 'పెండింగ్ మార్పులకు జోడించండి',
    pendingChanges: 'పెండింగ్ మార్పులు',
    noPendingChanges: 'ఇంకా పెండింగ్ మార్పులు లేవు',
    applyChanges: 'మార్పులను అమలు చేయండి',
    reset: 'రీసెట్',
    noMatchingRooms: 'సరిపోయే గదులు లేవు',
    noRoomsAvailable: 'అందుబాటులో గదులు లేవు',
    roomNumber: 'గది నంబర్',
    roomName: 'గది పేరు',
    status: 'స్థితి',
    currentSchedule: 'ప్రస్తుత షెడ్యూల్',
    selectAllRooms: 'అన్ని గదులను ఎంచుకోండి',
    selectRoom: 'గది {{number}} ఎంచుకోండి',
    dayLabel: 'రోజు',
    timeLabel: 'సమయం',
    filterTimesLabel: 'సమయాలను ఫిల్టర్ చేయండి',
    removePendingAria: 'గది {{room}} పెండింగ్ వేక్-అప్ తొలగించు, {{time}}',
    cancelWakeupAria: 'గది {{room}} {{time}} వేక్-అప్ రద్దు చేయండి',
  },
  history: {
    noHistory: 'వేక్-అప్ కాల్ చరిత్ర లేదు',
    noMatchingRecords: 'సరిపోయే రికార్డులు కనబడలేదు',
    showing: '{{count}} లో {{start}} నుండి {{end}} వరకు చూపిస్తోంది',
    filteredFromTotal: '(మొత్తం {{total}} ఎంట్రీల నుండి ఫిల్టర్ చేయబడింది)',
    room: 'గది',
    roomName: 'గది పేరు',
    attempts: 'ప్రయత్నాలు',
    wakeupDateTime: 'వేక్-అప్ తేదీ & సమయం',
    activationDateTime: 'యాక్టివేషన్ తేదీ & సమయం',
    wakeupStatus: 'వేక్-అప్ స్థితి',
    originator: 'మూలం',
    originPhone: 'ఫోన్',
    originPortal: 'పోర్టల్',
  },
  settings: {
    activation: 'యాక్టివేషన్',
    searchRoomsOrNames: 'గది లేదా పేరుతో వెతకండి...',
    noMatchingExtensions: 'మీ వెతుకులాటకు సరిపోయే ఎక్స్‌టెన్షన్‌లు లేవు',
    noExtensionsForPbx: 'ఈ PBX కోసం ఎక్స్‌టెన్షన్ లైన్లు కనబడలేదు',
    active: 'యాక్టివ్',
    roomNumber: 'గది నంబర్',
    extensionName: 'ఎక్స్‌టెన్షన్ పేరు',
    currentStatus: 'ప్రస్తుత స్థితి',
    roomActiveAria: 'గది {{number}} సక్రియం',
    statusAtTime: '{{status}} ({{time}} - {{date}})',
    activated: 'యాక్టివేట్ చేయబడింది',
    deactivated: 'డియాక్టివేట్ చేయబడింది',
    roomToggleStatus: 'గది {{roomNumber}} {{action}}',
    toggleHospitalityFailed: 'హాస్పిటాలిటీ టాగుల్ చేయడంలో విఫలమైంది',
    resetRoomsToDirty: 'గదులను Dirty కి రీసెట్ చేయండి',
    everyDayAt: 'ప్రతి రోజు @',
    manually: 'మాన్యువల్‌గా',
    saveSchedule: 'సేవ్ చేయండి',
    scheduleSaveFailed: 'రీసెట్ షెడ్యూల్ నవీకరించడంలో విఫలమైంది',
    manualResetEnabled: 'గది స్థితి మాన్యువల్‌గా రీసెట్ చేయబడుతుంది',
    dailyResetAt: 'గది స్థితి ప్రతి రోజు {{time}} కు రీసెట్ అవుతుంది',
  },
} satisfies HotelsLocale
